// assets/citymeals-kal.js
document.addEventListener("DOMContentLoaded", () => {
  const VARIANTS = {
    petite: 41381755093125,
    grand: 41381755125893
  };

  const donationBySet = {
    petite: "$25 from your purchase supports Citymeals",
    grand: "$50 from your purchase supports Citymeals"
  };

  // Elements
  const cartButtons = document.querySelectorAll(".js-add-to-cart");
  const stickyBar = document.querySelector(".sticky-mobile-bar");
  const stickyCartBtn = stickyBar ? stickyBar.querySelector(".js-add-to-cart") : null;
  const stickyDonationMsgSpan = stickyBar ? stickyBar.querySelector(".donation-message span") : null;
  const stickySetButtons = stickyBar ? stickyBar.querySelectorAll(".set-button") : [];

  // Initial State: Petite is the default active set
  let activeSet = 'petite';

  // Function to update the sticky bar's state (button dataset and message)
  const updateStickyBar = (set) => {
    activeSet = set;

    // 1. Update the 'Add to Cart' button's dataset
    if (stickyCartBtn) {
      stickyCartBtn.dataset.set = set;
    }

    // 2. Update the donation message
    if (stickyDonationMsgSpan) {
      stickyDonationMsgSpan.textContent = donationBySet[set];
    }

    // 3. Update the visual state of the set buttons
    stickySetButtons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.set === set);
    });
  };

  // --- Event Handlers for Sticky Set Selection ---
  stickySetButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      updateStickyBar(btn.dataset.set);
    });
  });

  // --- Event Handlers for Add to Cart Buttons ---
  cartButtons.forEach((btn) => {
    btn.addEventListener("click", async () => {
      const set = btn.dataset.set;
      const variantId = VARIANTS[set];
      if (!variantId) return alert("Variant not found.");

      // 🧩 Create a fake form compatible with ajax-cart.js
      const form = document.createElement("form");
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "id";
      input.value = variantId;
      form.appendChild(input);

      // Add optional hidden qty=1
      const qty = document.createElement("input");
      qty.type = "hidden";
      qty.name = "quantity";
      qty.value = "1";
      form.appendChild(qty);

      try {
        // ✅ Use the native Timber Ajax Cart system with callback
        ShopifyAPI.addItemFromForm(form, (item) => {
          console.log(`✅ Added ${set} set via ShopifyAPI.addItemFromForm()`, item);

          // Force refresh + open drawer animation using theme-native logic
          if (typeof ajaxCart !== "undefined" && typeof ajaxCart.load === "function") {
            ajaxCart.load();

            // Wait for cart to reload, then open drawer via theme.mfpOpen
            setTimeout(() => {
              document.body.dispatchEvent(new CustomEvent("afterCartLoad.ajaxCart"));
              if (typeof theme !== "undefined" && typeof theme.mfpOpen === "function") {
                theme.mfpOpen("cart");
              }
            }, 600);
          } else if (typeof theme !== "undefined" && typeof theme.mfpOpen === "function") {
            theme.mfpOpen("cart");
          }

          // Update sticky bar state to reflect the item just added
          if (stickyDonationMsgSpan) updateStickyBar(set);
        });
      } catch (err) {
        console.error("❌ Add to cart error:", err);
        alert("Unable to add to cart. Please try again.");
      }
    });
  });

  // Initialize the sticky bar on load
  if (stickyBar) {
    updateStickyBar(activeSet);
  }

  // Smooth scroll to the corresponding set section when sticky bar buttons are clicked
  const setButtons = document.querySelectorAll('.sticky-mobile-bar .set-button');

  setButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      // Get which button was clicked (petite / grand)
      const setType = btn.dataset.set || btn.getAttribute('data-set');
      const targetId = setType === 'grand' ? '#grand' : '#petite'; // default to petite
      const targetSection = document.querySelector(targetId);

      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll('items-scroll').forEach(el => {
    // Mimic what the theme’s section script normally does
    el.setAttribute('scroll-enabled', '');
    el.setAttribute('scrollable', '');
  });

  initBookModals();
  initScrollButtons();


});

// 1. Store the book data
const bookBlurbs = {
  "What's Good?": "Ingredient-driven stories and recipes from a pioneering NYC chef; a love letter to markets and seasons.",
  "Cooking with My Dad, the Chef": "A playful, heartfelt father–daughter collaboration that celebrates curiosity and the joy of cooking together.",
  "Preserving Wild Foods": "Foraging-rooted techniques and pantry craft—pickling, fermenting, and preserving with purpose.",
  "Relae: A Book of Ideas": "Simple, Michelin-starred cuisine from the former Copenhagen restaurant, offering articulate inspiration and accessible New Nordic recipes beyond local ingredients.",
  "Cooking by Hand": "A chef's evolution through craft—charcuterie, pasta, and the philosophy of cooking well.",
  // The "Petite Tasting Set" card doesn't need a blurb, so we can omit it.
};

// 2. Main function to set up the modals
function initBookModals() {
  document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('click', () => {
      const titleEl = card.querySelector('.book-title');
      const subtitleEl = card.querySelector('.book-subtitle');

      if (titleEl) {
        const title = titleEl.textContent.trim();
        const subtitle = subtitleEl ? subtitleEl.textContent.trim() : '';
        const blurb = bookBlurbs[title]; // Look up the blurb by title

        // Only show modal if we have content for it
        if (blurb) {
          showCitymealsModal({ title, subtitle, blurb });
        }
      }
    });
  });
}

// 3. Function to show and manage a modal

function showCitymealsModal({ title, subtitle, blurb }) {
  const overlay = document.getElementById('cm-modal-overlay');
  const modal = document.getElementById('cm-modal');
  const contentContainer = document.getElementById('cm-modal-content');
  const closeBtn = document.getElementById('cm-modal-close');

  if (!overlay || !modal || !contentContainer || !closeBtn) {
    console.error("Modal elements not found in the DOM.");
    return;
  }

  contentContainer.innerHTML = `
    <h3 id="cm-modal-title">${title}</h3>
    <p class="subtitle">${subtitle}</p>
    <p>${blurb}</p>
  `;

  overlay.style.display = 'block';
  modal.style.display = 'block';
  modal.focus();

  let closeTimer;

  function closeModal() {
    overlay.style.display = 'none';
    modal.style.display = 'none';
    clearTimeout(closeTimer);
    
    // Clean up event listeners
    document.removeEventListener('keydown', handleEscKey);
    closeBtn.removeEventListener('click', closeModal);
    // **Remove the overlay click listener**
    overlay.removeEventListener('click', closeModal);
  }

  function handleEscKey(event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  }

  // Add event listeners to close the modal
  closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', handleEscKey);
  // **Add a click listener to the overlay**
  overlay.addEventListener('click', closeModal);

  closeTimer = setTimeout(closeModal, 10000);
}

// Re-run when Shopify re-renders the section in the theme customizer
document.addEventListener('shopify:section:load', initBookModals);

function initScrollButtons() {
  const carousels = document.querySelectorAll('items-scroll');

  carousels.forEach(carousel => {
    const scrollContainer = carousel.querySelector('[data-items]');
    // Prevent re-initializing
    if (!scrollContainer || carousel.querySelector('.navigation')) {
      return;
    }

    // 1. Create the main 'navigation' wrapper div
    const navContainer = document.createElement('div');
    navContainer.className = 'navigation cm-navigation-container';

    // 2. Use the theme's exact HTML structure for the buttons and icons
    navContainer.innerHTML = `
      <button type="button" class="navigation__button navigation__button--prev" aria-label="Previous" data-navigation-prev>
        <i class="icon icon--left" aria-hidden="true"></i>
      </button>
      <button type="button" class="navigation__button navigation__button--next" aria-label="Next" data-navigation-next>
        <i class="icon icon--right" aria-hidden="true"></i>
      </button>
    `;

    // 3. Append the entire navigation container to the carousel
    carousel.appendChild(navContainer);

    // 4. Find the buttons *inside* the new container
    const prevButton = navContainer.querySelector('[data-navigation-prev]');
    const nextButton = navContainer.querySelector('[data-navigation-next]');

    // --- Add Click Events (this logic remains the same) ---
    prevButton.addEventListener('click', () => {
      const scrollAmount = scrollContainer.clientWidth * 0.8;
      scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      const scrollAmount = scrollContainer.clientWidth * 0.8;
      scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // --- Disable Buttons at Start/End (this logic remains the same) ---
    const updateButtonStates = () => {
      const scrollLeft = Math.ceil(scrollContainer.scrollLeft);
      const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      
      prevButton.disabled = scrollLeft < 1;
      nextButton.disabled = scrollLeft >= maxScroll - 1;
    };

    scrollContainer.addEventListener('scroll', updateButtonStates);
    updateButtonStates();
  });
}